/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskTriggerHealthCheckResponse
 */
export interface ExecRiskTriggerHealthCheckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ExecRiskTriggerHealthCheckResponse
     */
    success: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskTriggerHealthCheckResponse
     */
    created: number;
}

/**
 * Check if a given object implements the ExecRiskTriggerHealthCheckResponse interface.
 */
export function instanceOfExecRiskTriggerHealthCheckResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "created" in value;

    return isInstance;
}

export function ExecRiskTriggerHealthCheckResponseFromJSON(json: any): ExecRiskTriggerHealthCheckResponse {
    return ExecRiskTriggerHealthCheckResponseFromJSONTyped(json, false);
}

export function ExecRiskTriggerHealthCheckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskTriggerHealthCheckResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'created': json['created'],
    };
}

export function ExecRiskTriggerHealthCheckResponseToJSON(value?: ExecRiskTriggerHealthCheckResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'created': value.created,
    };
}

